import BaseAPIService from '../base/base-api-service';
import PartReturnModel from 'src/model/partReturn.model';

class PartSmartService extends BaseAPIService<PartReturnModel> {
  public partSmartEndpoint = 'accountapp/v1/partsmart/account';
  public partSmartLoginEndpoint = 'accountapp/v1/partsmart/login';
 
  constructor() {
    super(PartReturnModel);
  }
  

  public refreshPartSmartToken(): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.partSmartEndpoint}/rmalists`,
      method: 'get'
    }).then(res => res.data);
  }

  public getPartSmartToken(): Promise<any> {
    return this.doRequest({
      baseURL: this.baseURL,
      url: `${this.partSmartEndpoint}/authenticate`,
      method: 'get'
    }).then(res => res.data);
  }
 
  public getPartSmartLogin(accessToken: string, parrSmartUsrname: string, partSmartEmail: string) {
     return new Promise((resolve, reject) => {
      this.doRequest({
        baseURL: this.baseURL,
        method: 'post',
        url: `${this.partSmartLoginEndpoint}`,
        data: {
          username: parrSmartUsrname,
          email: partSmartEmail
        },
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error);
        });
        
    });
  }
}

const partSmartServiceInstance = new PartSmartService();
Object.freeze(partSmartServiceInstance);

export default partSmartServiceInstance;